export const FETCH_APP_STATUS_TYPES = 'initappactions/FETCH_APP_STATUS_TYPES';
export const FETCH_APP_STATUS_TYPES_FAILED = 'initappactions/FETCH_APP_STATUS_TYPES_FAILED';
export const FETCH_APP_STATUS_TYPES_SUCCESS = 'initappactions/FETCH_APP_STATUS_TYPES_SUCCESS';